import { Link, } from 'react-router-dom';
import React, { useState, useEffect, useRef } from 'react';

import localLibrary from './../utils/localLibrary';
import config from '../config';

function BookmarkButton(props) {
	const [selected, setSelected] = useState(false);
	const [popupVisible, setPopupVisible] = useState(false);

	useEffect(() => {
	}, []);

	let toggleSaveToLibrary = () => {
		var libraryItem = {
			id: props.id,
			title: props.title,
			type: props.type,
			baer: props.baer,
			baerid: props.baer_id
		};

		if (!localLibrary.find(libraryItem)) {
			localLibrary.add(libraryItem);

			setPopupVisible(true);

			setTimeout(() => setPopupVisible(false), 3000);
		}
		else {
			localLibrary.remove(libraryItem);
			setPopupVisible(false);
		}

		localLibrary.sendSignal();
	}

	let saved = localLibrary.find({
		id: props.id
	});

	return <span className={'tool-button bookmark-button'+(' '+props.className)+(saved ? ' selected' : '')}>
		<button alt={props.label || (saved ? 'Eyða úr lista' : 'Geyma')}
			title={props.label || (saved ? 'Eyða úr lista' : 'Geyma')}
			onClick={() => {
			   toggleSaveToLibrary();
		   }} />
		{
			<span className={'popup-info'+(popupVisible ? ' visible' : '')}>Hægt er að skoða þínar skrár <Link to="/minarskrar">hér</Link> eða í valmyndinni hér að ofan.</span>
		}
	</span>;
}

export default BookmarkButton;



// WEBPACK FOOTER //
// ./src/components/BookmarkButton.js